/**
 * Clé de contrôle GS1 (mod 10, spécifications générales GS1 §7.9). Fonction pure : elle vérifie un
 * identifiant attribué par une autorité, elle n'en fabrique aucun (ADR-017, ADR-053).
 */
/** Longueurs admises des clés numériques entièrement contrôlées, par type. */
const LENGTHS = {
    gtin: [8, 12, 13, 14],
    gln: [13],
    sscc: [18],
};
/** Vrai si le dernier chiffre de `digits` est la clé mod 10 GS1 des précédents. */
export function gs1Mod10Valid(digits) {
    if (!/^\d{2,}$/.test(digits))
        return false;
    let sum = 0;
    const body = digits.slice(0, -1);
    // Poids 3 puis 1, en partant du chiffre le plus proche de la clé.
    for (let index = 0; index < body.length; index += 1) {
        const digit = Number(body[body.length - 1 - index]);
        sum += index % 2 === 0 ? digit * 3 : digit;
    }
    return (10 - (sum % 10)) % 10 === Number(digits[digits.length - 1]);
}
/**
 * Clé de contrôle d'un identifiant GS1 selon son type. `grai` : un zéro, 13 chiffres dont la clé,
 * puis un numéro de série alphanumérique optionnel (16 au plus). `giai` n'a pas de clé : sa forme
 * seule est vérifiée. Tout autre type est hors GS1 et rend `false`.
 */
export function gs1CheckDigitValid(value, identifierType) {
    const lengths = LENGTHS[identifierType];
    if (lengths !== undefined)
        return lengths.includes(value.length) && gs1Mod10Valid(value);
    if (identifierType === 'grai')
        return /^0\d{13}[\x21-\x7a]{0,16}$/.test(value) && gs1Mod10Valid(value.slice(1, 14));
    if (identifierType === 'giai')
        return /^[\x21-\x7a]{1,30}$/.test(value);
    return false;
}
//# sourceMappingURL=gs1.js.map